import { Alert, Button, Form, Input, Typography } from 'antd';

import { ERROR_REQUIRED_FIELD, OFF } from '@app/constants';

import type { AccessCodeFormValues } from '@pages/Authorization/Authorization.types';

import type { FormInstance } from 'antd';
import type { ChangeEventHandler, FC } from 'react';

import '@pages/Authorization/ui/components/AccessCode.scss';

interface AccessCodeProps {
  clearServerErrorHandler: () => void;
  codeChangeHandler: ChangeEventHandler<HTMLInputElement>;
  email: string;
  finishHandler: (values: AccessCodeFormValues) => Promise<void>;
  form: FormInstance<AccessCodeFormValues>;
  isSubmitLoader: boolean;
  serverError: string;
}

export const AccessCode: FC<AccessCodeProps> = ({
  clearServerErrorHandler,
  codeChangeHandler,
  email,
  finishHandler,
  form,
  isSubmitLoader,
  serverError,
}) => (
  <Form
    form={form}
    className="AccessCode"
    name="basic"
    initialValues={{ remember: true }}
    autoComplete={OFF}
    onFinish={finishHandler}
  >
    <Typography className="AccessCode__label">
      Введите <b>код доступа</b> из письма
      {email && <span>, отправленного на {email}</span>}
    </Typography>
    <Form.Item
      name="code"
      rules={[{ required: true, message: ERROR_REQUIRED_FIELD }]}
    >
      <Input
        className="AccessCode__field"
        size="large"
        onChange={codeChangeHandler}
      />
    </Form.Item>

    {serverError && (
      <div className="AccessCode__alert-container">
        <Alert
          className="AccessCode__alert"
          description={serverError}
          type="error"
          showIcon
          onClick={clearServerErrorHandler}
        />
      </div>
    )}

    <Form.Item className="AccessCode__button-container">
      <Button
        className="AccessCode__sign-in-button"
        loading={isSubmitLoader}
        type="primary"
        size="large"
        htmlType="submit"
      >
        Войти
      </Button>
    </Form.Item>
  </Form>
);
